<div class="app" *ngIf="loggedUser">
  <app-header [sideNavOpen]="sidenavOpened" [sideNavOpenable]="sidenavOpenable"
              (toggleSideNav)="toggleSideNav()" (openFilterDialog)="openFilterDialog()"
              [currentRoute]="currentRoute"
  ></app-header>
  <mat-sidenav-container autosize>
    <mat-sidenav [mode]="sidenavOpenable ? 'over': 'side'" [opened]="sidenavOpened" (closed)="closeSideNav()">
      <app-navigation
          [title]="departmentTitle"
          [isExpanded]="navExpanded"
          (beforeNavigate)="sidenavOpenable? toggleSideNav() : undefined"
      ></app-navigation>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
